import { render, staticRenderFns } from "./AdministrativePainel.vue?vue&type=template&id=448d9a50&scoped=true&"
import script from "./AdministrativePainel.vue?vue&type=script&lang=js&"
export * from "./AdministrativePainel.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativePainel.vue?vue&type=style&index=0&id=448d9a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d9a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
